<template>
    <q-card :inline="inline"
            :class="['card ', {inEdit: inEdit}]"
            @dragover.native.prevent="() => {}"
            @drop.native="drop"
            :draggable="true"
            @dragstart.native="ondragstart"
    >
        <q-card-title style="padding: 0; text-align: center">
            <template v-if="inEdit">
                <q-field label="Nazwa">
                    <q-input v-model="model.label"></q-input>
                </q-field>
            </template>
            <template v-else>
                {{model.label}}
            </template>
        </q-card-title>

        <q-card-media class="text-center">
            <image-viewer :src="model.thumbUrl" v-if="model.thumbUrl"/>
        </q-card-media>

        <q-card-actions align="end" class="actions" v-if="editable">
            <publish-button :model="model" what="badge"/>
            <q-btn flat dense round icon="edit" @click.native="edit"/>
            <q-btn flat dense round icon="delete" @click.native="confirmAndDelete"/>
        </q-card-actions>
    </q-card>
</template>

<script>
    import QCard from 'quasar-framework/src/components/card/QCard'
    import QCardTitle from 'quasar-framework/src/components/card/QCardTitle'
    import ImageViewer from './pole/viewers/ImageViewer'
    import QCardMedia from 'quasar-framework/src/components/card/QCardMedia'
    import QField from 'quasar-framework/src/components/field/QField'
    import QInput from 'quasar-framework/src/components/input/QInput'
    import PublishButton from './pole/PublishButton'
    export default {
        name: 'BadgeComponent',
        props: ['model', 'inline', 'inEdit', 'editable'],
        components: {PublishButton, QInput, QField, QCardMedia, ImageViewer, QCardTitle, QCard},
        methods: {
            ondragstart (e) {
                e.dataTransfer.effectAllowed = 'copy'
                e.dataTransfer.setData('text', JSON.stringify(this.model))
            },
            confirmAndDelete () {
                this.$q.dialog({
                    title: `Potwierdź usunięcie odznaki`,
                    message: `Czy na pewno usunąć odznakę ${this.model.label}?`,
                    ok: 'Usuń',
                    cancel: 'Anuluj',
                    position: 'top',
                }).then(() => {
                    this.$store.dispatch('remove', {
                        what: 'badge',
                        id: this.model.badgeId
                    })
                }).catch(() => {

                })
            },
            edit () {
                this.$router.push({
                    name: 'badge-edit',
                    params: {
                        badgeId: this.model.badgeId
                    }
                })
            },
            drop (e) {
                if (this.inEdit) {
                    this.model.thumbUrl = JSON.parse(e.dataTransfer.getData('text')).urlPath
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .card {
        width: 150px;
        &.inEdit {
            width: 300px;
        }
        border-radius: 20px;

        img {
            width: 100px;
            margin: 0 auto;
        }

        .actions {
            background-color: gainsboro;
        }
    }
</style>